import { createEntityAdapter } from '@reduxjs/toolkit';

import { AppliedTrainingProfile } from 'data/training';

const appliedProfileAdapter = createEntityAdapter<AppliedTrainingProfile>({
  selectId: (appliedProfile) => `${appliedProfile.farmId}#${appliedProfile.type}`,
});

export default appliedProfileAdapter;
